










































































































import { Component } from "vue-property-decorator";

import MagicValidator from "../../../magic/MagicValidator.vue";
import WidgetBase from "../WidgetBase";

import { uploadSingleAttachment } from "../../../api/index";

import { PUBLIC_ASSETS_PATH, uid } from "@szgc/plt-core-v2";
import { ntko_addon } from "../../../ntko/index";

import { Loading } from "element-ui";

@Component({
  name: "NtkoH5Widget",
  components: { MagicValidator }
})
export default class NtkoH5Widget extends WidgetBase {
  public visible: boolean = false;

  private docViewerHelper!: any;

  public id: string = "r" + uid();

  private readerInited: boolean = false;

  public signed: boolean = false;

  public oldSignList: any[] = [];
  public newSignList: any[] = [];

  public loading!: any;

  save() {
    const jwtKey = this.sysconfig.jwtKey;
    const token = this.sysconfig.jwt + "";
    const upload_url = new URL(location.origin + "/api/appproc/ruanhang/file/upload");
    upload_url.searchParams.append(jwtKey, token);
    upload_url.searchParams.append("pacId", this.widget.pac.pacId);
    upload_url.searchParams.append("businessId", this.widget.pac.businessId);
    upload_url.searchParams.append("propertyName", this.widget.property.propertyName);
    console.log("上传地址", upload_url);
    this.loading = Loading.service({
      lock: true,
      fullscreen: true,
      text: "签章保存中..."
    });
    this.docViewerHelper.save(upload_url.toString());
  }

  showH5Sign() {
    this.visible = true;
  }

  async closeH5Sign() {
    if (!this.signed) {
      this.visible = false;
    } else {
      let confirm;
      try {
        confirm = await this.$confirm("有新签章尚未保存，确定要关闭？", "提示", {
          type: "warning"
        });
      } catch (error) {
        confirm = false;
      }
      if (!confirm) return;
      this.visible = false;
    }
  }

  async onSignOpened() {
    if (!this.readerInited) {
      if (!document.newDocumentSdk) {
        this.$alert("签章控件未正确安装", "提示", {
          confirmButtonText: "确定",
          type: "error",
          callback: () => {
            this.visible = false;
          }
        });
      }

      this.docViewerHelper = document.newDocumentSdk();
      const embedReaderPrams: Record<string, unknown> = {
        viewMode: "DigitalSign",
        signMode: ntko_addon.signMode || "Server"
      };
      if (ntko_addon.authorizeCallback) {
        if (typeof ntko_addon.authorizeCallback === "string") {
          embedReaderPrams.authorizeCallback = ntko_addon.authorizeCallback;
        } else if (typeof ntko_addon.authorizeCallback === "function") {
          embedReaderPrams.authorizeCallback = await ntko_addon.authorizeCallback(this.current);
        }
      }
      if (ntko_addon.unauthorizeCallback) {
        if (typeof ntko_addon.unauthorizeCallback === "string") {
          embedReaderPrams.unauthorizeCallback = ntko_addon.unauthorizeCallback;
        } else if (typeof ntko_addon.unauthorizeCallback === "function") {
          embedReaderPrams.unauthorizeCallback = await ntko_addon.unauthorizeCallback(this.current);
        }
      }
      if (ntko_addon.unauthorizeCallback) {
        embedReaderPrams.unauthorizeCallback = ntko_addon.unauthorizeCallback;
      }

      this.docViewerHelper.embedReader(this.id, ntko_addon.reader_iframe_url, embedReaderPrams);

      this.docViewerHelper.setReaderEventListener((event: any, payload: any) => {
        console.log("阅读器事件:", event, payload);
      });

      this.docViewerHelper.addSignServerAuthCallback(async (credentials: any) => {
        if (typeof credentials.error === "string") {
          // 登录失败
          console.log("addSignServerAuthCallback 1", credentials.error);
        } else if (typeof credentials.canDoSign === "boolean" && !credentials.canDoSign) {
          console.log("addSignServerAuthCallback 2", "你没有签章权限");
        } else if (typeof credentials.signOut === "boolean" && !!credentials.signOut) {
          console.log("addSignServerAuthCallback 3", "登出成功");

          let account: string = "",
            password: string = "";

          if (ntko_addon.account_convert && ntko_addon.password_convert) {
            if (typeof ntko_addon.account_convert === "string") {
              account = ntko_addon.account_convert;
            } else if (typeof ntko_addon.account_convert === "function") {
              account = await ntko_addon.account_convert(this.current);
            }

            if (typeof ntko_addon.password_convert === "string") {
              password = ntko_addon.password_convert;
            } else if (typeof ntko_addon.password_convert === "function") {
              password = await ntko_addon.password_convert(this.current);
            }
          }
          console.log("尝试使用账号密码登录", account, password);
          // 尝试登录印章服务器
          this.docViewerHelper.loginSignServer(
            // 印章服务器URL
            ntko_addon.h5_svr_url,
            // 用户名
            account,
            // 登录密码
            password
          );
        } else {
          console.log(
            "addSignServerAuthCallback 4",
            "登录成功:" + (credentials.realName || credentials.userName)
          );
        }
      });

      this.docViewerHelper.addDocumentOpenedCallback((status: any, error: any) => {
        if ("ok" === status) {
          // 设置默认印章密码
          // 盖章时不再弹窗密码框
          this.docViewerHelper.setDefaultSealPassword("111111");

          // 设置默认证书密码
          this.docViewerHelper.setDefaultKeystorePassword("111111");

          // 退出
          this.docViewerHelper.signOutSignServer();

          // 尝试登录印章服务器
          // this.docViewerHelper.loginSignServer(
          //   // 印章服务器URL
          //   ntko_addon.h5_svr_url,
          //   // 用户名
          //   "zhangsan",
          //   // 登录密码
          //   "111111"
          // );

          this.signed = false;
        } else if ("error" === status) {
          alert("打开文档失败");
        } else {
          if ("download-failed" === status) {
            console.warn("下载文档失败", error);
          } else if ("invalid-file-type" === status) {
            console.warn("不支持的文件格式");
          } else {
            console.warn(error || "打开文档失败");
          }

          this.docViewerHelper.closeDocument();
        }
      });

      /**
       * 阅读器加载完成事件
       */
      this.docViewerHelper.addReaderReadyCallback(() => {
        console.log("this.docViewerHelper.addReaderReadyCallback");

        this.docViewerHelper.setSignServer(ntko_addon.h5_svr_url);
        // 在文档打开后设定用户信息
        // 接受两种格式的参数，当为字符类型时，设置用户名；为对象类型时设置JSON格式的用户详细信息
        // docViewerHelper.setSessionUser('测试用户513');
        // this.docViewerHelper.setSessionUser({
        //   userName: "zhangsan",
        //   userId: "123456"
        // });

        const file_url = new URL(location.origin + this.ext.requestRelativeUri);
        const jwtKey = this.sysconfig.jwtKey;
        const token = this.sysconfig.jwt + "";
        file_url.searchParams.append(jwtKey, token);

        console.log("file_url", file_url.toString());

        const fileOptions = {
          fileName: this.ext.fileName,
          fileUrl: file_url.toString(),
          readOnly: false
        };

        this.docViewerHelper.openPdfDocument(fileOptions, (e: any) => {
          console.log("OpenEvent", e);
          if (e.error) {
            alert("打开文档失败: " + e.error);
            return;
          }

          if (e.status !== "ok") {
            // 打开文档失败
          } else {
            //打开文档成功
            this.docViewerHelper.listDigitalSignatures();
          }
        });
      });

      this.docViewerHelper.addDigitalSignatureRetrieveCallback((value: any) => {
        if (typeof value === "object" && typeof value.length === "number") {
          if (value.length > 0) {
            this.oldSignList = JSON.parse(JSON.stringify(value));
          }
        }
      });

      this.docViewerHelper.onDigitalSignaturesParsed = (event: any) => {
        this.newSignList = JSON.parse(JSON.stringify(event.payload.signatures));
      };

      this.docViewerHelper.onFileUploadComplete = (event: any) => {
        this.loading && this.loading.close();
        const payload = event.payload;
        if (payload.error) {
          this.$alert("保存签章失败", "提示", {
            confirmButtonText: "确定",
            type: "error"
          });
        } else {
          const resp = JSON.parse(payload.response);
          if (!resp.success) {
            this.$alert("保存签章失败", "提示", {
              confirmButtonText: "确定",
              type: "error"
            });
          } else {
            const ext = {
              attId: resp.data.attId,
              fileName: resp.data.fileName,
              requestRelativeUri: resp.data.requestRelativeUri
            };

            this.ext = ext;

            this.$set(this.widget, "ext", ext);
            this.$set(this.widget, "value", resp.data.attId);

            this.value = resp.data.attId;

            this.$alert("保存签章成功", "提示", {
              confirmButtonText: "确定",
              type: "success",
              callback: () => {
                this.visible = false;
              }
            });
          }
        }
      };

      /**
       * 签章回调事件
       */
      this.docViewerHelper.onDocumentSignedWithResult = (event: any) => {
        if (event.payload.signed) {
          this.signed = true;
        } else {
          this.$alert("签章失败，" + event.payload.error, "提示", {
            confirmButtonText: "确定",
            type: "error",
            callback: () => {
              this.visible = false;
            }
          });
        }
      };
    }
  }

  created() {
    this.ext = this.widget.ext || {};
  }

  public ext: { attId: string; fileName: string; requestRelativeUri: string } = {
    attId: "",
    fileName: "",
    requestRelativeUri: ""
  };

  view() {
    const src = PUBLIC_ASSETS_PATH + "pdfjs/web/viewer.html?file=" + this.ext.requestRelativeUri;
    window.open(src);
  }

  async deleteFile() {
    let confirm;
    try {
      confirm = await this.$confirm("确定删除文件？", "提示", {
        type: "warning"
      });
    } catch (error) {
      confirm = false;
    }
    if (!confirm) return;
    this.$set(this.widget, "value", "");
  }

  download() {
    const a = document.createElement("a");
    a.href = this.ext.requestRelativeUri;
    a.download = this.ext.fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  async onFileChange(data: { raw: File }) {
    const formData = new FormData();
    formData.append("file", data.raw);
    formData.append("propertyNamePath", this.widget.path);
    formData.append("reqToken", this.widget.pac.reqToken);

    try {
      const res = await uploadSingleAttachment(
        this.widget.pac.pacId,
        this.widget.pac.businessId,
        formData
      );
      if (res.success) {
        this.$set(this.widget, "value", res.data.fileId);
        this.$set(this, "value", res.data.fileId);
        this.ext.attId = res.data.fileId;
        this.ext.fileName = res.data.name;
        this.ext.requestRelativeUri = res.data.requestUri;
      }
    } catch (error) {
      console.log(error);
    }
  }

  onUploadSuccess(res: any) {
    console.log(res);
  }
}
